import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getOfferType, isFlat, isOffice, isSuburbanResidential, isUrban } from '../../../utils/offer_type';
import { getDealType, isRent } from '../../../utils/deal_type';

export const getOfferText = (offer: IOfferSchema) => {
  const mainText = 'Проверенный риелтор поможет';
  const offerType = getOfferType(offer);
  const dealType = getDealType(offer);
  const dealTypeText = isRent(dealType) ? 'снять или сдать' : 'купить или продать';

  if (isOffice(offerType)) {
    return `${mainText} ${dealTypeText} офис`;
  }

  if (isFlat(offerType)) {
    return `${mainText} ${dealTypeText} квартиру`;
  }

  if (isUrban(offerType)) {
    return `${mainText} ${dealTypeText} жилье`;
  }

  if (isSuburbanResidential(offerType)) {
    return `${mainText} ${dealTypeText} дом`;
  }

  return `${mainText} ${dealTypeText} недвижимость`;
};
